import {
    serverErrors,
    serverMessages,
    clientMessages,
    defaultMessages,
    passThroughErrors,
} from './enums/ErrorMessages';

function isLanguageKey(message) {
    return /^validation\.[\w.]+$/.test(message) || /^[\w-]+::[\w.]+$/.test(message);
}

export function errorMessage(error, defaultMessage = '') {
    let key = null;
    let message = null;

    key = error?.response?.data?.title;
    // If an error from an api tries to get a message for this error.
    if (key) {
        const errorMessage = serverErrors[key];

        if (errorMessage) {
            return errorMessage;
        }

        // These carry a ready user-facing message that names the offending field, so there is
        // nothing to map it to — show what the server said.
        if (passThroughErrors.includes(key) && error?.response?.data?.message) {
            return error.response.data.message;
        }

        // 403 bears either the framework default «Access denied!» or a Russian sentence naming the
        // reason («Этот город вне вашей области доступа»). The latter is shown; the former is replaced.
        if (key === 'AccessDenied') {
            const reason = error?.response?.data?.message;

            return typeof reason === 'string' && /[А-Яа-яЁё]/.test(reason) ? reason : defaultMessages.ACCESS_DENIED;
        }
    }

    // Laravel 422 ValidationException carries no `title`, only { message, errors: { field: [msg] } }.
    // Without this the admin would see the generic fallback and never learn which field is invalid.
    // Only human-written messages are shown. Untranslated framework rules arrive as language keys
    // ("validation.required", "laravelEnum::messages.enum_value") — there are no lang files on the
    // backend — and showing them would expose internals instead of explaining anything.
    const validationErrors = error?.response?.data?.errors;
    if (validationErrors && typeof validationErrors === 'object') {
        const messages = Object.values(validationErrors)
            .flatMap((value) => (Array.isArray(value) ? value : [value]))
            .filter((value) => typeof value === 'string' && value.trim() !== '');

        const human = messages.find((value) => !isLanguageKey(value));

        if (human) {
            return human;
        }

        if (messages.length) {
            return defaultMessage ? defaultMessage : defaultMessages.INVALID_DATA;
        }
    }

    message = error?.response?.data?.message;
    if (message) {
        const errorMessage = serverMessages[message];

        if (errorMessage) {
            return errorMessage;
        }
    }

    // If an error from the js tries to get a message for this error.
    message = error?.message;
    if (message) {
        const errorMessage = clientMessages[message];

        if (errorMessage) {
            return errorMessage;
        }
    }

    return defaultMessage ? defaultMessage : defaultMessages.SOMETHING_WENT_WRONG;
}
